export const difficult = {
    // '01': { label: '최하', o: 0, x: 0 },
    '03': { label: '기초', o: 4, x: 0 },
    '04': { label: '핵심', o: 6, x: 2 },
    '05': { label: '심화', o: 8, x: 4 },
    // '05': { label: '최상', o: 0, x: 0 },
};
export const difficult_old = {
    '01': { label: '최하', o: 0, x: 0 },
    '02': { label: '기초', o: 4, x: 0 },
    '03': { label: '핵심', o: 6, x: 2 },
    '04': { label: '심화', o: 8, x: 4 },
    '05': { label: '최상', o: 0, x: 0 },
};

export const drill = {
    up: 1,
    down: -1,
};

export const drillArea = {
    '02': { up: -2, down: 5 },
    '03': { up: 6, down: 11 },
    '04': { up: 12, down: 16 },
};

export const analysis = {
    5077: { label: '사실적', ord: 1 },
    5078: { label: '추론적', ord: 2 },
    5079: { label: '비판적', ord: 3 },
    5085: { label: '감상적', ord: 3 },
    5080: { label: '개념', ord: 4 },
    5081: { label: '어휘', ord: 4 },
};
export const studyTree = {
    5082: '코어독해',
    5083: '본격독해',
    5086: '본격독해_확인',
    5084: '어휘학습',
};

export const element = {
    5090: '핵심 소재 및 내용 파악',
    5091: '중심 내용 파악 및 구조화',
    5092: '주제 및 핵심 표현 정리',
    5093: '어휘의 사전적 의미 파악',
    5094: '예문을 통한 어휘 쓰임 파악',
    5095: '문맥적 의미 확인을 통한 어휘 적용',
    5096: '한자성어를 통한 어휘 확장',
};
export const headerEtcCd02 = {
    '01': '문학',
    '02': '비문학',
    '03': '문학+비문학',
    '04': '복합지문',
    '05': '문학_운문',
    '06': '문학_산문',
};
export const headerEtcCd01 = {
    '01': '동요',
    '02': '전래동요',
    '03': '동화',
    '04': '생활문',
    '05': '동시/시',
    '06': '극본/희곡',
    '07': '방송극본',
    '08': '시조',
    '09': '전설',
    10: '방송 대본',
    11: '민담',
    12: '고전 소설',
    13: '소설',
    14: '신화',
    15: '수필',
    16: '만화',
    17: '민요',
    18: '노랫말',
    19: '고려가요',
    20: '향가',
    21: '고전 수필',
    22: '중수필',
    23: '시나리오',
    24: '뮤지컬 대본',
    25: '우화',
    26: '고대 가요',
    27: '한시',
    28: '서사 무가',
    29: '설명문',
    30: '그림일기/일기',
    31: '편지',
    32: '전기문',
    33: '견학 기록문',
    34: '독서 감상문',
    35: '논설문',
    36: '관찰 기록문',
    37: '기행문',
    38: '연설문',
    39: '영화 감상문',
    40: '조사 기록문',
    41: '연극 감상문',
    42: '안내문',
    43: '기사문',
    44: '광고문',
    45: '음악 감상문',
    46: '미술 감상문',
    47: '서평',
    48: '자서전',
    49: '건의문',
    50: '호소문',
    51: '상소문',
    52: '비평문',
    53: '논평',
    54: '촌평',
    55: '면담 기사',
    56: '선언문',
    57: '이야기',
    58: '그림책',
    59: '드라마 대본',
    60: '드라마',
    61: '영화',
    62: '소개하는 글',
    63: '편지+전기문',
    64: '일기+동화',
    65: '독서감상문+편지',
    66: '듣기 대본',
    67: '극본+편지',
    68: '전기문+동화',
    69: '논설문+설명문',
    70: '영화감상문+전기문',
    71: '생활문+동화',
    72: '현대시',
    73: '현대시: 현대 시조',
    74: '고전시가: 시조',
    75: '고전시가: 가사',
    76: '고전시가: 경기체가',
    77: '고전시가: 악장',
    78: '고전시가: 한시',
    79: '고전시가: 고대가요',
    80: '고전시가: 향가',
    81: '고전시가: 민요',
    82: '현대소설',
    83: '극수필: 희곡',
    84: '극수필: 시나리오',
    85: '극수필: 수필',
    86: '고전산문: 고전 소설',
    87: '고전산문: 고전 수필',
};

export const headerEtcCd05 = {
    '01': '과학: 물리',
    '02': '과학: 화학',
    '03': '과학: 지구과학',
    '04': '과학: 생물',
    '05': '과학: 기술',
    '06': '과학: 생명공학',
    '08': '과학: 수학/과학사',
    '09': '과학: 의학/약학/뇌과학',
    10: '예술: 음악',
    11: '예술: 미술',
    12: '예술: 무용(춤)',
    13: '예술: 사진',
    14: '예술: 스포츠',
    15: '예술: 건축/디자인',
    16: '예술: 만화/영화/영상/극/문학',
    17: '예술: 예술일반/미술/미학/서예_동양',
    18: '예술: 예술일반/미술/미학/서예_서양',
    20: '사회: 역사',
    21: '사회: 정치',
    22: '사회: 경제',
    23: '사회: 문화',
    24: '사회: 지리',
    30: '인문: 언어',
    31: '인문: 철학',
    32: '인문: 철학/사상_동양',
    33: '인문: 철학/사상_서양',
    34: '인문: 역사_동양',
    35: '인문: 역사_서양',
    36: '인문: 종교/윤리/인류',
    37: '인문: 논리/심리/인지/감성/언어',
    40: '정치사회: 법학/법률',
    41: '정치사회: 행정/정책',
    42: '정치사회: 정치/선거',
    43: '정치사회: 언론/매체',
    44: '정치사회: 관계/국제',
    45: '정치사회: 복지/생활/여성/인권/노동',
    50: '경제문화: 경제/경영',
    51: '경제문화: 무역/통화/소비',
    52: '경제문화: 문화',
    53: '경제문화: 인류/신화',
    54: '경제문화: 지리/도시/지역',
    60: '기술: 통신/음향/전기전자/광학',
    61: '기술: 컴퓨터/IT기술/실용',
    62: '기술: 로봇/우주',
    63: '기술: 건설/기계',
    64: '기술: 교통(항공, 자동차, 선박)/산업',
    65: '기술: 에너지/자원/원자력/환경/화공',
    90: '융합: 인문',
    91: '융합: 예술',
    92: '융합: 정치사회',
    93: '융합: 경제문화',
    94: '융합: 과학',
    95: '융합: 기술',
};

export const headerBookCd_old = {
    63: '독해 트레이닝',
    64: '수능 지문',
    65: '교과 지문',
    66: '단행본 지문',
    67: '눈높이국어 지문',
    68: '창의독서 지문',
    69: '솔루니 지문',
    70: '올림피아드 지문',
    71: '모의평가 지문',
};
export const headerBookCd = {
    64: '수능 지문',
    65: '교과 지문',
};

export const learningType = {
    NORMAL: { label: '맞춤학습', color: '#EAF8EE', code: '1' },
    SAT: { label: '수능', color: '#37C16C', code: '2' },
    SUGGESTION_MANUAL: { label: '추천학습', color: '#D8F6FF', code: '3' }, // 수동
    SUGGESTION_AUTO: { label: '추천학습', color: '#D8F6FF', code: '4' }, // 자동
    SUGGESTION_DIAGNOSTIC: { label: '진단추천', color: '#D8F6FF', code: '5' }, //진단
    NORMAL_RESET: { label: '맞춤리셋', color: '#FBEBEF', code: '6' },
    SUGGESTION_RESET: { label: '추천리셋', color: '#E8DFFF', code: '7' },
    SAT_RESET: { label: '수능리셋', color: '#37C16C', code: '8' },
};

export const learningTypeForWrongList = {
    1: { label: '맞춤학습', color: '#EAF8EE', code: '1' },
    3: { label: '추천학습', color: '#D8F6FF', code: '3' },
    5: { label: '진단추천', color: '#D8F6FF', code: '5' },
    6: { label: '맞춤학습', color: '#EAF8EE', code: '6' },
};

export const learningStatus = {
    W: '대기',
    I: '진행중',
    C: '완료',
    R: '리셋',
    D: '중단',
    S: '중단',
};
export const problemType = {
    typeall: '전체 내용을\n묻는 질문',
    typepart: '세부 내용을\n묻는 질문',
    typepositive: '긍정형 질문',
    typenegative: '부정형 질문',
    typeoptionexist: '<보기>있는 질문​',
    typeoptionnone: '<보기>없는 질문​',
};
export const classList = {
    Y1_01: '현대시',
    Y1_02: '현대소설',
    Y1_03: '고전시가',
    Y1_04: '고전산문',
    Y1_05: '극수필',
    Y5_01: '인문',
    Y5_02: '과학',
    Y5_03: '정치사회',
    Y5_04: '예술',
    Y5_05: '기술',
    Y5_06: '경제문화',
    Y5_07: '융합',
};

export const analysisOrd = {
    5077: 1,
    5078: 2,
    5079: 3,
    5085: 4,
    5080: 5,
    5081: 6,
};
